import { generateUtilityClass } from '@mui/material';
import { unstable_generateUtilityClasses as generateUtilityClasses } from '@mui/utils';

export interface AlertBaseClasses {
  /** Styles applied to the root element. */
  root: string;
  /**
   * Styles applied when props.severity = 'info'
   */
  severityInfo: string;
  /**
   * Styles applied when props.severity = 'success'
   */
  severitySuccess: string;
  /**
   * Styles applied when props.severity = 'warning'
   */
  severityWarning: string;
  /**
   * Styles applied when props.severity = 'error'
   */
  severityError: string;
}

export type AlertBaseClassKey = keyof AlertBaseClasses;

export function getAlertBaseUtilityClass(slot: string): string {
  return generateUtilityClass('UnifyAlertBase', slot);
}

const alertBaseClasses: AlertBaseClasses = generateUtilityClasses(
  'UnifyAlertBase',
  [
    'root',
    'severityInfo',
    'severitySuccess',
    'severityWarning',
    'severityError',
  ]
);

export default alertBaseClasses;
